import { CommonPullupMenuComponent } from './common-pullup-menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { CommonPullupMenuRoutingModule } from './common-pullup-menu-routing.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CommonPullupMenuRoutingModule
  ],
  declarations: [CommonPullupMenuComponent]
})
export class CommonPullupMenuModule { }
